var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login-main", class: _vm.bgStatus ? "login-bg" : "" },
    [
      _c("div", { staticClass: "login-header" }, [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "lh-cut", staticStyle: { display: "none" } }, [
          _c("i", {
            class: _vm.bgStatus ? "" : "lh-cut-active",
            on: {
              click: function($event) {
                return _vm.clickGround(false)
              }
            }
          }),
          _c("i", {
            class: _vm.bgStatus ? "lh-cut-active" : "",
            staticStyle: { background: "#062247" },
            on: {
              click: function($event) {
                return _vm.clickGround(true)
              }
            }
          })
        ])
      ]),
      _vm._m(2),
      _c("div", { staticClass: "login-footer" }, [
        _c(
          "div",
          {
            staticClass: "lf-top",
            staticStyle: { "padding-bottom": "5px", border: "none" }
          },
          [
            _vm._m(3),
            _c(
              "div",
              {
                staticClass: "lf-copyright",
                staticStyle: { "justify-content": "center" }
              },
              [
                _c("div", [
                  _c("span", [
                    _vm._v(
                      "© 2002-" +
                        _vm._s(_vm.nowDate) +
                        " 宏脉信息技术（广州）股份有限公司 版权所有"
                    )
                  ]),
                  _c(
                    "span",
                    {
                      staticStyle: { "margin-left": "20px", cursor: "pointer" },
                      on: { click: _vm.toPolice }
                    },
                    [_vm._v("粤ICP证：11080780号")]
                  ),
                  _c("img", {
                    staticStyle: {
                      "margin-left": "20px",
                      width: "17px",
                      height: "19px",
                      "margin-right": "10px",
                      transform: "translate(0, 5px)"
                    },
                    attrs: { src: require("../assets/img/police.png") }
                  }),
                  _c(
                    "span",
                    {
                      staticClass: "lf-span",
                      staticStyle: { cursor: "pointer" },
                      on: { click: _vm.toPolice }
                    },
                    [_vm._v("广公网安备 44011302001028号")]
                  )
                ])
              ]
            )
          ]
        ),
        _c("div", { staticClass: "lf-top" }, [
          _vm._m(4),
          _c("div", { staticClass: "lf-copyright" }, [
            _c("div", { staticStyle: { display: "none" } }, [
              _c("img", {
                staticStyle: {
                  width: "17px",
                  height: "19px",
                  "margin-right": "10px"
                },
                attrs: { src: require("../assets/img/police.png") }
              }),
              _c(
                "span",
                {
                  staticClass: "lf-span",
                  staticStyle: { cursor: "pointer" },
                  on: { click: _vm.toPolice }
                },
                [_vm._v("广公网安备 44011302001028号")]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lh-left" }, [
      _c("img", { attrs: { src: require("../assets/img/hmc_logo.png") } }),
      _vm._v(" 宏脉软件 ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lh-right" }, [
      _c("span", [_vm._v("客莱宝SCRM")]),
      _c("div", { staticClass: "lhr-centen" }, [
        _c("p", [
          _c("img", { attrs: { src: require("../assets/img/qiye_logo.png") } })
        ]),
        _c("span", [_vm._v("企业微信服务商")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "login-centen" }, [
      _c("div", { staticClass: "login-left" }, [
        _c("img", {
          attrs: { src: require("../assets/img/group_bail.png"), alt: "客莱宝" }
        })
      ]),
      _c("div", { staticClass: "login-box" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { display: "none" } }, [
      _c("li", [_vm._v("关于我们")]),
      _c("li", [_vm._v("廉政举报")]),
      _c("li", [_vm._v("联系我们")]),
      _c("li", [_vm._v("加入宏脉")]),
      _c("li", [_vm._v("法律声明及隐私权政策")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ul", { staticStyle: { display: "none" } }, [
      _c("li", [_vm._v("宏脉集团")]),
      _c("li", [_vm._v("宏脉院务系统")]),
      _c("li", [_vm._v("宏脉医生App")]),
      _c("li", [_vm._v("宏脉微信商城")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }